/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { useRef, useEffect } from "react";

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { IAbsoluteFfViewProps } from './absolute-ff';

export default (props: IAbsoluteFfViewProps) => {

    let animateThis1 = useRef(null);
    let animateThat1 = useRef(null);
    let animateThis2 = useRef(null);
    let animateThat2 = useRef(null);
    let animateThis3 = useRef(null);
    let animateThat3 = useRef(null);
    let animateThis4 = useRef(null);
    let animateThat4 = useRef(null);
    let animateThis5 = useRef(null);
    let animateThat5 = useRef(null);
    let animateThis6 = useRef(null);
    let animateThat6 = useRef(null);
    let animateThis7 = useRef(null);
    let animateThat7 = useRef(null);
    let animateThis8 = useRef(null);
    let animateThat8 = useRef(null);

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
    
        gsap.to( animateThis1, {
            scrollTrigger: {
                trigger: '.feature1', 
                scrub: 1,
            },
            duration: 2,
            x: '-20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat1, {
            scrollTrigger: {
                trigger: '.feature1',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })
    
        gsap.to( animateThis2, {
            scrollTrigger: {
                trigger: '.feature2', 
                scrub: 1,
            },
            duration: 2,
            x: '20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat2, {
            scrollTrigger: {
                trigger: '.feature2',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })
    
        gsap.to( animateThis3, {
            scrollTrigger: {
                trigger: '.feature3', 
                scrub: 1,
            },
            duration: 2,
            x: '-20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat3, {
            scrollTrigger: {
                trigger: '.feature3',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })
    
        gsap.to( animateThis4, {
            scrollTrigger: {
                trigger: '.feature4', 
                scrub: 1,
            },
            duration: 2,
            x: '20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat4, {
            scrollTrigger: {
                trigger: '.feature4',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })
    
        gsap.to( animateThis5, {
            scrollTrigger: {
                trigger: '.feature5', 
                scrub: 1,
            },
            duration: 2,
            x: '-20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat5, {
            scrollTrigger: {
                trigger: '.feature5',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })
    
        gsap.to( animateThis6, {
            scrollTrigger: {
                trigger: '.feature6', 
                scrub: 1,
            },
            duration: 2,
            x: '20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat6, {
            scrollTrigger: {
                trigger: '.feature6',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })

        gsap.to( animateThis7, {
            scrollTrigger: {
                trigger: '.feature7', 
                scrub: 1,
            },
            duration: 2,
            x: '-20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat7, {
            scrollTrigger: {
                trigger: '.feature7',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })

        gsap.to( animateThis8, {
            scrollTrigger: {
                trigger: '.feature8', 
                scrub: 1,
            },
            duration: 2,
            x: '20',
            y: '60',
            ease: "ease-in",
        })
        gsap.from( animateThat8, {
            scrollTrigger: {
                trigger: '.feature8',  
                //start: "top bottom",
                toggleActions: "restart none none reverse"
            },
            duration: 1.5,
            opacity: 0,
            ease: "ease-in",
        })

    
    
    }, [])

    const { 
        obFFTitle1, 
        obFFTitle2, 
        obFFTitle3,
        obFFTitle4,
        obFFTitle5,
        obFFTitle6,
        obFFTitle7,
        obFFTitle8, 
        obFFContent1, 
        obFFContent2,
        obFFContent3,
        obFFContent4, 
        obFFContent5,
        obFFContent6,
        obFFContent7,
        obFFContent8, 
        obFFImage1,
        obFFImage2,
        obFFImage3,
        obFFImage4,
        obFFImage5,
        obFFImage6,
        obFFImage7,
        obFFImage8,
        buttonText1,
        buttonLink1,
        buttonText2,
        buttonLink2,
        buttonText3,
        buttonLink3,
        buttonText4,
        buttonLink4,
        buttonText5,
        buttonLink5,
        buttonText6,
        buttonLink6,
        buttonText7,
        buttonLink7,
        buttonText8,
        buttonLink8,
        links1,
        links2,
        links3,
        links4,
        links5,
        links6,
        links7,
        links8
           
    } = props;

    return (
        <div className="feature-focus">
            <div className="white-background">
                <div className="inside-xxl">
                
           
                {obFFImage1 ? (
                    <div className="flex-md feature1">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis1 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat1 = el}}
                                >
                                    {obFFImage1}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                        {obFFTitle1}
                          <div className="feature-content">{obFFContent1}</div>
                          {buttonLink1 ? (
                          <div className="around-button"><a className="button" href={buttonLink1}>{buttonText1}</a></div>
                          ) : null}
                          {links1}
                        </div>
                    </div>
                ) : null}

                {obFFImage2 ? (
                    <div className="flex-md feature2">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis2 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat2 = el}}
                                >
                                    {obFFImage2}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                        {obFFTitle2}
                          <div className="feature-content">{obFFContent2}</div>
                          {buttonLink2 ? (
                          <div className="around-button"><a className="button" href={buttonLink2}>{buttonText2}</a></div>
                          ) : null}
                          {links2}
                        </div>
                    </div>
                ) : null}

                {obFFImage3 ? (
                    <div className="flex-md feature3">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis3 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat3 = el}}
                                >
                                    {obFFImage3}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                        {obFFTitle3}
                          <div className="feature-content">{obFFContent3}</div>
                          {buttonLink3 ? (
                          <div className="around-button"><a className="button" href={buttonLink3}>{buttonText3}</a></div>
                          ) : null}
                          {links3}
                        </div>
                    </div>
                ) : null}

                {obFFImage4 ? (
                    <div className="flex-md feature4">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis4 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat4 = el}}
                                >
                                    {obFFImage4}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                        {obFFTitle4}
                          <div className="feature-content">{obFFContent4}</div>
                          {buttonLink4 ? (
                          <div className="around-button"><a className="button" href={buttonLink4}>{buttonText4}</a></div>
                          ) : null}
                          {links4}
                        </div>
                    </div>
                ) : null}

                {obFFImage5 ? (
                    <div className="flex-md feature5">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis5 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat5 = el}}
                                >
                                    {obFFImage5}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                        {obFFTitle5}
                          <div className="feature-content">{obFFContent5}</div>
                          {buttonLink5 ? (
                          <div className="around-button"><a className="button" href={buttonLink5}>{buttonText5}</a></div>
                          ) : null}
                          {links5}
                        </div>
                    </div>
                ) : null}

                {obFFImage6 ? (
                    <div className="flex-md feature6">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis6 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat6 = el}}
                                >
                                    {obFFImage6}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                        {obFFTitle6}
                          <div className="feature-content">{obFFContent6}</div>
                          {buttonLink6 ? (
                          <div className="around-button"><a className="button" href={buttonLink6}>{buttonText6}</a></div>
                          ) : null}
                          {links6}
                        </div>
                    </div>
                ) : null}

                {obFFImage7 ? (
                    <div className="flex-md feature7">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis7 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat7 = el}}
                                >
                                    {obFFImage7}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                        {obFFTitle7}
                          <div className="feature-content">{obFFContent7}</div>
                          {buttonLink7 ? (
                          <div className="around-button"><a className="button" href={buttonLink7}>{buttonText7}</a></div>
                          ) : null}
                          {links7}
                        </div>
                    </div>
                ) : null}

                {obFFImage8 ? (
                    <div className="flex-md feature8">
                        <div 
                            className="sixty" 
                            ref={el => {
                            //@ts-ignore
                            animateThis8 = el}}
                        >
                            <div className="animateBackground">
                                <div 
                                    className="animateThat"
                                    ref={el => {
                                    //@ts-ignore
                                    animateThat8 = el}}
                                >
                                    {obFFImage8}
                                </div>
                            </div>
                        </div>
                        <div className="forty flex-vertical">
                        {obFFTitle8}
                          <div className="feature-content">{obFFContent8}</div>
                          {buttonLink8 ? (
                          <div className="around-button"><a className="button" href={buttonLink8}>{buttonText8}</a></div>
                          ) : null}
                          {links8}
                        </div>
                    </div>
                ) : null}
                
                </div>
       
            </div>
        </div>
        
    );
};
